import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import MovieCreationOutlinedIcon from "@mui/icons-material/MovieCreationOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import { addNewGame, getGamesData } from "../redux/asyncThunk/userActions";
import { useNavigate } from "react-router-dom";
import { sanitizePlainText } from "../utils/inputValidation";
import { AUTH_FIELD_SX } from "../pages/AuthLayout";
import { CONTENT_TYPES } from "../utils/contentType";

export default function NewGame() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const games = useSelector((state) => state.user?.games);
  const user = useSelector((state) => state.user?.data?.user);

  const [textProject, setTextProject] = useState("");
  const [contentType, setContentType] = useState(CONTENT_TYPES.scenario);

  const checkGamesTitle = useCallback(
    (count) => !games.find((el) => el.title === `Новый проект-${count}`),
    [games]
  );

  useEffect(() => {
    if (!games?.length) {
      setTextProject("Новый проект-1");
    } else {
      let count = 1;
      while (!checkGamesTitle(count)) {
        count++;
      }
      setTextProject(`Новый проект-${count}`);
    }
  }, [checkGamesTitle, games]);

  return (
    <div className="app-dialog__body">
      <div className="app-dialog__title">Создайте проект</div>

      <span className="app-dialog__label">Тип проекта</span>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={contentType}
        onChange={(_, value) => {
          if (value) setContentType(value);
        }}
        className="app-dialog__type-toggle"
      >
        <ToggleButton value={CONTENT_TYPES.scenario}>
          <MovieCreationOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
          Сценарий
        </ToggleButton>
        <ToggleButton value={CONTENT_TYPES.trainer}>
          <QuizOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
          Тренажёр
        </ToggleButton>
      </ToggleButtonGroup>

      <p className="app-dialog__hint">
        {contentType === CONTENT_TYPES.trainer
          ? "Вопросы с вариантами ответов, проверка правильности и статистика прохождений."
          : "Интерактивный сценарий с видео и ветвлением по выбору."}
      </p>

      <TextField
        label="Название проекта"
        value={textProject}
        size="small"
        fullWidth
        sx={AUTH_FIELD_SX}
        onChange={(ev) =>
          setTextProject(sanitizePlainText(ev.target.value, 120))
        }
      />
      <div className="app-dialog__actions">
        <Button
          variant="contained"
          className="app-btn app-btn--primary"
          onClick={() => {
            const onSuccess = () => {
              dispatch(getGamesData({ id: user.id }));
              navigate("/main", { replace: true });
            };
            dispatch(
              addNewGame({
                userId: user.id,
                textProject,
                contentType,
                onSuccess,
              })
            );
          }}
        >
          Создать
        </Button>
      </div>
    </div>
  );
}
